import { useState } from "react";

import { db, auth } from "./firebase";

import {
  collection,
  addDoc
} from "firebase/firestore";

function AddHouse({ goBack }) {

  const [
    propertyCategory,

    setPropertyCategory

  ] = useState("");

  const [town, setTown] =
    useState("");

  const [area, setArea] =
    useState("");

  const [estate, setEstate] =
    useState("");

  const [
    plotName,

    setPlotName

  ] = useState("");

  const [
    houseType,

    setHouseType

  ] = useState("");

  const [rent, setRent] =
    useState("");

  const [
    contact,

    setContact

  ] = useState("");
const [email, setEmail] = useState("");
const [landlordName, setLandlordName] = useState("");
  const addHouse =
  async () => {

    if (

      !propertyCategory ||

      !town ||

      !area ||

      !plotName ||

      !houseType ||

      !rent ||

      !contact ||
      !landlordName
       

    ) {

      alert(
        "Please fill all fields"
      );

      return;
    }

    try {

      await addDoc(

        collection(
          db,
          "houses"
        ),

        {

          propertyCategory,

          town,

          area,

          estate,

          plotName,

          houseType,

          rent:Number(rent),

          contact,
          landlordName,
          email,

          ownerId: auth.currentUser ? auth.currentUser.uid : null,
          status:
          "available",

          createdAt:
          new Date()

        }

      );

      alert(
      "Property added successfully!"
      );

      setPropertyCategory("");

      setTown("");

      setArea("");

      setEstate("");

      setPlotName("");

      setHouseType("");

      setRent("");

      setContact("");
      setLandlordName("");
      setEmail("");
    }

    catch(err){

      alert(err.message);

    }

  };

  return (

    <div

      style={{

        minHeight:"100vh",

        background:
        "linear-gradient(135deg,#000,#1a1a1a,#ffd600)",

        padding:"30px"

      }}

    >

      <button

        onClick={goBack}

      >

        ⬅ Back

      </button>

      <div

        style={{

          maxWidth:"700px",

          margin:"20px auto",

          background:"white",

          padding:"30px",

          borderRadius:"25px"

        }}

      >

        <h1>

          ➕ Add Property

        </h1>

        <select

          value={
          propertyCategory
          }

          onChange={(e)=>

          setPropertyCategory(

          e.target.value

          )

          }

          style={inputStyle}

        >

          <option value="">

          Select Category

          </option>

          <option>

          Residential

          </option>

          <option>

          Commercial

          </option>

        </select>

        <select

          value={town}

          onChange={(e)=>

          setTown(

          e.target.value

          )

          }

          style={inputStyle}

        >

          <option value="">

          Select Town

          </option>

          <option>

          Nairobi

          </option>

          <option>

          Mombasa

          </option>

          <option>

          Kisumu

          </option>

          <option>

          Nakuru

          </option>

          <option>

          Eldoret

          </option>

          <option>

          Machakos

          </option>
<option>
Kithimani-Yatta
</option>
          <option>

          Kitui

          </option>

          <option>

          Thika

          </option>

          <option>

          Meru

          </option>

          <option>

          Nyeri

          </option>

        </select>

        <input

          placeholder="Area"

          value={area}

          onChange={(e)=>

          setArea(

          e.target.value

          )}

          style={inputStyle}

        />

        <input

          placeholder="Estate (Optional)"

          value={estate}

          onChange={(e)=>

          setEstate(

          e.target.value

          )}

          style={inputStyle}

        />

        <input

          placeholder="Plot Name"

          value={plotName}

          onChange={(e)=>

          setPlotName(

          e.target.value

          )}

          style={inputStyle}

        />

        <select

          value={houseType}

          onChange={(e)=>

          setHouseType(

          e.target.value

          )}

          style={inputStyle}

        >

          <option value="">

          Select Type

          </option>

          {propertyCategory ===
          "Residential"

          &&

          <>

          <option>

          Single Room

          </option>

          <option>

          Bedsitter

          </option>

          <option>

          Double Room

          </option>

          <option>

          1 Bedroom Apartment

          </option>

          <option>

          2 Bedroom Apartment

          </option>

          <option>

          3 Bedroom Apartment

          </option>

          <option>

          2 Bedroom Mansionette

          </option>

          <option>

          3 Bedroom Mansionette

          </option>

          <option>

          3 Bedroom Bungalow

          </option>

          </>

          }

          {propertyCategory ===
          "Commercial"

          &&

          <>

          <option>

          Office Space

          </option>

          <option>

          Shop

          </option>

          <option>

          Retail Space

          </option>

          <option>

          Warehouse

          </option>

          <option>

          Business Premises

          </option>

          <option>

          Commercial Building

          </option>

          </>

          }

        </select>

        <input

          type="number"

          placeholder="Rent"

          value={rent}

          onChange={(e)=>

          setRent(

          e.target.value

          )}

          style={inputStyle}

        />

        <input

          placeholder="Contact"

          value={contact}

          onChange={(e)=>

          setContact(

          e.target.value

          )}

          style={inputStyle}

        />
<input
  type="email"
  placeholder="Email Address (Optional)"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  style={inputStyle}
/>
<input
  type="text"
  placeholder="Landlord Name "
  value={landlordName}
  onChange={(e) => setLandlordName(e.target.value)}
  style={inputStyle}
/>
        <button

          onClick={addHouse}

          style={{

            width:"100%",

            padding:"15px",

            background:"#ffd600",

            border:"none",

            fontWeight:"bold"

          }}

        >

          Save Property

        </button>

      </div>

    </div>

  );

}

const inputStyle = {

width:"100%",

padding:"12px",

margin:"10px 0",

borderRadius:"10px",

border:"1px solid #ccc"

};

export default AddHouse;